import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    homeBannerDetails: {
        name: "",
        content: "",
        status: true,
    },
    modal: false,
    edit: false,
    homeBanners: [],
    loading: false,
    activeStatus: [],
    searchHomeBanner: ""
};

const HomeBannerReducer = createSlice({
    name: "homeBannerReducer",
    initialState: initialState,
    reducers: {
        updateHomeBannerDetails: (state, { payload }) => {
            state.homeBannerDetails = payload;
        },
        updateModal: (state, { payload }) => {
            state.modal = payload;
        },
        updateLoadingHomeBanners: (state, { payload }) => {
            state.loading = payload;
        },
        updateHomeBanners: (state, { payload }) => {
            state.homeBanners = payload;
        },
        updateActiveStatus: (state, { payload }) => {
            state.activeStatus = payload;
        },
        updateEdit: (state, { payload }) => {
            state.edit = payload;
        },
        updateSearchHomeBanner: (state, { payload }) => {
            state.searchHomeBanner = payload;
        },
    }
});

export const {
    updateModal,
    updateHomeBannerDetails,
    updateLoadingHomeBanners,
    updateHomeBanners,
    updateActiveStatus,
    updateEdit,
    updateSearchHomeBanner
} = HomeBannerReducer.actions;

export default HomeBannerReducer.reducer;
